import ServerDataGrid from "../../../components/datagrid/ServerDataGrid";
import { columns } from "./columns";

export function RebatesTablePage() {
  return (
    <ServerDataGrid
      columns={columns}
      getRowId={(row) => row.rebates.id}
      apiEndpoint="/datagrid/rebates"
      tableName="rebates"
      enableCreate={false}
      enableSearch={true}
    />
  );
}
